var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "34px",
    height: "34px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    fill: "rgba(244,246,245,0)",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#3666c5",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64,256c-35.34622,0 -64,-28.65378 -64,-64v-128c0,-35.34622 28.65378,-64 64,-64h128c35.34622,0 64,28.65378 64,64v128c0,35.34622 -28.65378,64 -64,64z",
    id: "shape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,10h-16v28h16c0.553,0 1,-0.447 1,-1v-26c0,-0.553 -0.447,-1 -1,-1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,15.001h14v1.999h-14zM25,19h14v2h-14zM25,23.001h14v2h-14zM25,27.001h14v1.999h-14zM25,31h14v2.001h-14z",
    fill: "#3666c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,42l-21,-4v-28l21,-4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.167,31.012h-2.717l-1.802,-8.988c-0.098,-0.477 -0.155,-0.996 -0.174,-1.576h-0.032c-0.043,0.637 -0.11,1.162 -0.197,1.576l-1.85,8.988h-2.827l-2.86,-14.014h2.675l1.536,9.328c0.062,0.404 0.111,0.938 0.143,1.607h0.042c0.019,-0.498 0.098,-1.051 0.223,-1.645l1.97,-9.291h2.622l1.785,9.404c0.062,0.348 0.119,0.846 0.17,1.511h0.031c0.02,-0.515 0.073,-1.035 0.16,-1.563l1.503,-9.352h2.468z",
    fill: "#3666c5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.d5ba7311cd51224b1da141e537c37926.svg";
export { ForwardRef as ReactComponent };